import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as SharedPagination } from "@cinch-nx/shared-ui";
import { useRouter } from "next/router";
export var Pagination = function(param) {
    var path = param.path, currentPage = param.currentPage, _resultsPerPage = param.resultsPerPage, resultsPerPage = _resultsPerPage === void 0 ? 10 : _resultsPerPage, total = param.total;
    var isFallback = useRouter().isFallback;
    if (isFallback) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SharedPagination, {
        totalItemsCount: total,
        activePage: currentPage,
        itemsCountPerPage: resultsPerPage,
        sourcePage: path,
        enabledLinks: true
    });
};
